(function() {
	let query = document.getElementById('orderBy');

	if (query) {
		query.removeAttribute('hidden');

		query.addEventListener('change', function() {
			let search = document.querySelector('.js-product-search');
			if (search) {
				search.submit();
			}
		});
	}
})();

(function() {
	let filter = document.getElementById('categoryFilter');

	if (filter) {
		filter.addEventListener('change', function(e) {
			window.location.href = e.target.value;
		});
	}
})();
